<div class="row justify-content-between align-items-center mdc-dialog__title">
  <h5 class="col-10 col-md-10 mb-0 text-left">Validacion de {{data.tipo}}</h5>
</div>
<mat-dialog-content>
  <div class="row m-0 pt-3 justify-content-center" [formGroup]="formTwoFactorCode">
    <h1 class="col-12 text-center mb-3 letrasPortal">Atlas Conmigo</h1>
    <p class="col-12 text-center">Hemos enviado un codigo al {{data.tipo}} para validar tu identidad</p>
    <hr class="col-12">
    <h5 class="col-12 m-3 text-center">Tu código expira en: {{formatTime(intervalo)}}</h5>
    <a class="col-12 mb-3 text-center">Para continuar, ingrese el código de verificación de 6 dígitos que enviamos a
    tu {{data.tipo}} {{data.valor}}. </a>
    <div class="col-md-6">
      <mat-form-field class="w-100">
        @if (!bloqueoCodigo) {
          <input type="password" #twoFactorCodeInput autofocus matInput maxlength="6"
            formControlName="TwoFactorCode" placeholder="Escribe el código">
        }
        @if (formTwoFactorCode.get('TwoFactorCode').hasError('required')) {
          <mat-error>El campo es obligatorio
          </mat-error>
        }
        @if (!reenvio) {
          <mat-error>{{msgError}}</mat-error>
        }
      </mat-form-field>
      <p class="text-right contrasenia">
        @if (!reenvio) {
          <button mat-raised-button color="primary" (click)=" resendCode()">
            <span>Solicitar nuevo código</span>
          </button>
        }
      </p>
      <p class="text-right mensaje-procesando">@if (procesando) {
        <span><i class="fas fa-sync fa-spin"></i>
      Procesando...</span>
    }</p>
  </div>
</div>
</mat-dialog-content>
<mat-dialog-actions class="row m-0 justify-content-center pb-5">
  <div class="col-auto">
        <button mat-raised-button color="primary" [disabled]="formTwoFactorCode.invalid || procesando" (click)="
            ValidarCodigoTwoFactorCode()">
      @if (!loading) {
        <span>Validar Codigo</span>
      }
      @if (loading) {
        <span><i class="fas fa-sync fa-spin"></i> Cargando...</span>
      }
    </button>
    <button mat-raised-button color="primary" (click)=" closeDialog('Proceso Cancelado')">
      <span>Cancelar</span>
    </button>
  </div>
</mat-dialog-actions>